import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { useLoadHeaderData } from '@/pages/all/Event/PageViewEvent/useLoadHeaderData';
import { usePageViewLog } from '@/pages/all/Event/PageViewEvent/usePageViewLog';
export const PageViewEvent = () => {
    const unmountRef = useUnmountRef();
    const location = useLocation();
    const { pathname } = location;
    const auth = useTypeSelector((state) => state.auth);
    const isIgnorePage = useMemo(() => {
        const ignoreList = ['/project/client/:id'];
        return !!ignoreList.find((v) => !!matchPath({
            caseSensitive: false,
            end: true,
            path: v,
        }, pathname));
    }, [pathname]);
    // アクセス履歴の登録
    usePageViewLog({
        isIgnorePage,
        location,
        unmountRef,
    });
    // ヘッダー用に必要なデータの読み込み
    useLoadHeaderData({
        auth,
        isIgnorePage,
        location,
        unmountRef,
    });
    return null;
};
